import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { communicationsHorizontalNavEntrypoint } from '@atlassian/jira-communications-horizontal-nav/entrypoint.tsx';
import { communicationsStakeholdersEntrypoint } from '@atlassian/jira-communications-stakeholders/entrypoint.tsx';

export const stakeholdersPageEntrypoint = createPageEntryPoint({
	main: communicationsStakeholdersEntrypoint,
	topNavigationMenuId: MENU_ID.COMMUNICATIONS,
	horizontalNavigation: communicationsHorizontalNavEntrypoint,
});
